/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import cookies from 'react-cookies';
import Modal from 'react-modal';
import api from '../../../services/api';
import {
  Container,
  Bottom,
  Header,
  ModalConfirm,
  Left,
  NewContractContent,
  Top,
  Body,
} from './styles';
import like from '../../../assets/icons/like.svg';
import { LoaderIcon } from '../../../components/Loader';
import './styles.css';

export interface dataServerDTO {
  created_at: string;
  creditor: dataTableInfo;
  debtor: dataTableInfo;
  due_date: string;
  total_value: string;
  id: number;
  percentage_value: string;
  status: string;
  updated_at?: string;
}
export interface dataTableInfo {
  affiliation_key: string;
  document: string;
  fantasy_name: string;
  id: number;
  legal_name: string;
  on_registry: boolean;
  stone_code: string;
}
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    borderRadius: '8',
    background: 'rgba(0,0,0,0)',
    border: 'none',
    padding: '-100px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const ReviewContract: React.FC = () => {
  const [cookie, setCookie] = useState<dataServerDTO>();
  const [loading, setLoading] = useState(false);
  const [modalConfirm, setModalConfirm] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const temp = localStorage.getItem('proposalInfoClient');
    if (temp) {
      setCookie(JSON.parse(temp));
    }
  }, []);

  async function confirmProposal() {
    setLoading(true);
    try {
      const response = await api.post(
        `${
          process.env.REACT_APP_API_REQUEST_ENDPOINT
        }/v0/gps/merchants/${cookies.load('external_stone_codes')}/proposals/${
          cookie?.id
        }/confirm`,
        cookie,
        {
          headers: {
            Authorization: `Bearer ${cookies.load('external_token')}`,
          },
        },
      );
      if (response.status !== 200 && response.status !== 204) {
        history.push('/notconnected');
      } else {
        setModalConfirm(true);
      }
      setLoading(false);
    } catch (error) {
      history.push('/notconnected');
    }
  }
  function closeModal() {
    setModalConfirm(false);
  }
  return (
    <Container>
      <NewContractContent>
        <Header>
          <h3>Confirmar Nova Proposta</h3>
        </Header>
        <Body>
          <Top>
            <Left>
              <div>
                <span>Nome Fantasia</span>
                <label>{cookie?.debtor.fantasy_name || 'Carregando'}</label>
              </div>
              <div>
                <span>CPF/CNPJ</span>
                <label>{cookie?.debtor.document || 'Carregando'}</label>
              </div>
              <div>
                <span>Stone Code</span>
                <label>{cookie?.debtor.stone_code || 'Carregando'}</label>
              </div>

              <div>
                <span>Data Limite</span>
                <label>
                  {`${cookie?.due_date.substring(
                    8,
                    10,
                  )}/${cookie?.due_date.substring(
                    5,
                    7,
                  )}/${cookie?.due_date.substring(0, 4)}` || 'Carregando'}
                </label>
              </div>
              <div>
                <span>Direcionamento</span>
                <label>{`${cookie?.percentage_value || 'Carregando'} %`}</label>
              </div>
            </Left>
          </Top>
          <Modal
            isOpen={modalConfirm}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            overlayClassName="Overlay"
            onAfterClose={() => {
              localStorage.removeItem('proposalInfoClient');
              history.push('/');
            }}
          >
            <ModalConfirm
              style={{
                background: '#0DB14B',
                border: '2px solid #1CBB5D',
              }}
            >
              <img
                src={like}
                alt="Confirmado"
                style={{ width: 80, height: 100, marginBottom: 20 }}
              />
              <h3 style={{ color: '#fff', fontSize: 36, textAlign: 'center' }}>
                Proposta
                <br />
                Criada :)
              </h3>
              <br />
              <div style={{ textAlign: 'center', fontSize: 20, color: '#fff' }}>
                {`Sua proposta com a loja ${
                  cookie?.debtor.fantasy_name || 'Carregando'
                }`}
                foi criada com sucesso!
                <br />
                {`ID da proposta: ${cookie?.id || 'Carregando'}`}
              </div>
              <Bottom>
                <button
                  type="button"
                  style={{ background: '#fff', color: '#0DB14B' }}
                  onClick={() => {
                    history.push('/');
                  }}
                >
                  Ir para o início
                </button>
              </Bottom>
            </ModalConfirm>
          </Modal>
          {!loading ? (
            <Bottom>
              <NavLink to="/newcontract"> Editar Proposta </NavLink>
              <button type="button" onClick={confirmProposal}>
                Continuar
              </button>
            </Bottom>
          ) : (
            <Bottom>
              <LoaderIcon />
            </Bottom>
          )}
        </Body>
      </NewContractContent>
    </Container>
  );
};
export default ReviewContract;
